module.exports = __webpack_public_path__ + "static/fasie-ru-e6bed9af28207365b48c402741cc914b.png";